<template>
  <div class="content main-container">
    <div class="top clearfix">
      <div class="info">
        <p>说明：</p>
        <p>1、本功能可用于查看和管理平台分销保单的结算费用。</p>
        <p class="p2">1)、每月18日，结算上月首期已过犹豫期（截止本月17日）且回执回访质检成功保单（法定节假日顺延）；</p>
        <p class="p2">2)、如有参加活动，每月20日结算上月参加活动，首期已过犹豫期且回执回访质检成功保单对应活动奖励（法定节假日顺延）；</p>
        <p class="p2">注：双录单/单录确权单需质检通过。</p>
        <p>2、待结算费用：出单后未退保，待达到结算条件或未到结算时间的收入。</p>
        <p>3、已结算明细：每期结算日结算后生成的账单，导出清单可查看当期全部已结算保单明细。</p>
        <p>
          4、可提现收入：每笔结算完成之后资金会自动进入可提现收入，满100元可向平台申请提现，平台将在收到发票后的5个工作日内（节假日顺延）安排线下付款。若提现申请状态显示“提现成功”，说明已向银行安排付款。因银行转账时间的差异，提现申请将在财务打款后的1-3日内到账。历史提现记录可在平台结算>个险结算>结算管理查看。
        </p>
        <p>5、“首年费用后置”比例，是指基于风险管理角度把首年费用后置缓发的一部分费用，该费用不受继续率考核限制，该比例对应的保费基数是指首年保费。</p>
        <p>6、续期结算规则：</p>
        <p class="p2">所有产品宽限期后第2个月10日按照平台规则发放续期服务费。</p>
        <p class="p2">举例：2023年9月1日-2023年9月30日生效的保单，续期缴费日为2024年9月1日-2024年11月30日，服务费生效（下发）日为2025年1月10日。</p>
      </div>
      <div class="blocks">
        <div class="tx">
          <div>可提现收入</div>
          <div>{{ availableAmount || '0.00' }}元</div>
        </div>
        <Button v-preventReClick type="primary" @click="withDrawal" style="width: 80px">提现</Button>
      </div>
      <div class="blocks">
        <div class="tx">
          <div>待结算费用（元）</div>
          <div>{{ waitAvailableAmount }}元</div>
        </div>
        <Button type="primary" @click="() => exportList()" ghost>导出清单</Button>
      </div>
    </div>
    <div class="hasDetail">已结算明细</div>
    <div class="searchBox clearfix">
      <div class="left">
        <my-form :formList="searchForm" ref="searchForm" span="6"></my-form>
      </div>
      <div class="right">
        <Button type="primary" @click="search">查询</Button>
      </div>
    </div>
    <div class="table-box setTable">
      <loading :isShow="$root.$children[0].isShowLoading" />
      <Table :columns="columns" :data="tableDate">
        <template slot-scope="{ row }" slot="action">
          <span @click="() => exportList(row.totalId, row.commissionPeriod)" class="table-btn"> 导出清单 </span>
        </template>
      </Table>
      <div class="pageBox">
        <Page :total="total" :current="pageNo" :page-size="pageSize" show-total @on-change="pageChange" style="text-align: center" />
      </div>
    </div>
    <!-- 选择提现记录 -->
    <numberWithdrawal ref="numberWithdrawal" @reload="getList"/>
  </div>
</template>

<script>
import myForm from '@/components/commons/form';
import numberWithdrawal from './components/numberWithdrawal';
import searchForm from './form/search';
import { mapState } from 'vuex';
import _ from 'lodash';
import { myExportAll, downloadInfo, getAvailableAmountWithdrawLog, waitWithdrawAfter } from '@/api/httpList';
export default {
  components: { numberWithdrawal, myForm },
  data() {
    return {
      userType: '',
      fold: true,
      waitAvailableAmount: '', //待结算金额
      availableAmount: '', //可提现金额
      tableDate: [],
      pageNo: 1,
      pageSize: 10,
      searchMore: true,
      total: 0,
      showWidthDraw: false,
      searchForm: [],
      columns: [
        {
          title: '结算类型',
          minWidth: 120,
          align: 'center',
          tooltip: true,
          key: 'settlementType',
          render(h, params) {
            const flag = params.row.settlementType;
            if (flag == '1') {
              return <span>首期</span>;
            } else if (flag == '2') {
              return <span>续期</span>;
            } else if (flag == '3') {
              return <span>后置服务费</span>;
            } else if (flag == '4') {
              return <span>梯度活动</span>;
            } else if (flag == '5') {
              return <span>继续率追偿</span>;
            }
          }
        },
        {
          title: '结算主体',
          align: 'center',
          key: 'subCompanyName',
          minWidth: 200
        },
        {
          title: '结算周期',
          align: 'center',
          key: 'commissionPeriod',
          minWidth: 100,
          tooltip: true
        },
        {
          title: '年数',
          align: 'center',
          key: 'settlementIndex',
          width: 80,
          tooltip: true
        },
        {
          title: '保单数',
          key: 'totalNumber',
          align: 'center',
          width: 80,
          tooltip: true
        },
        {
          title: '已结算保费（元）',
          key: 'totalPrice',
          align: 'center',
          minWidth: 160,
          tooltip: true
        },
        {
          title: '应结费用（元）',
          key: 'totalCommission',
          minWidth: 160,
          tooltip: true,
          renderHeader: (h, params) => {
            return (
              <Poptip trigger="hover" content="content" transfer={true} transfer-class-name="channelQrcode">
                <span>应结费用（元）</span>
                <span class="tip-icon">?</span>
                <div slot="content">
                  <span>商户及下级机构的业绩出单收入</span>
                </div>
              </Poptip>
            );
          },
          align: 'center'
        },
        {
          title: '发放金额（元）',
          key: 'sendCommission',
          align: 'center',
          minWidth: 160,
          tooltip: true,
          renderHeader: (h, params) => {
            return (
              <Poptip trigger="hover" content="content" transfer={true} transfer-class-name="channelQrcode">
                <span>发放金额（元）</span>
                <span class="tip-icon">?</span>
                <div slot="content">
                  <span>续期发放金额=应结费用*续期发放比例</span>
                </div>
              </Poptip>
            );
          }
        },
        {
          title: '实际收入（元）',
          key: 'settleCommission',
          minWidth: 160,
          tooltip: true,
          renderHeader: (h, params) => {
            return (
              <Poptip trigger="hover" content="content" transfer={true} transfer-class-name="channelQrcode">
                <span>实际收入（元）</span>
                <span class="tip-icon">?</span>
                <div slot="content">
                  <span>商户及下级机构扣税后的实际到账收入</span>
                </div>
              </Poptip>
            );
          },
          align: 'center'
        },
        {
          title: '操作',
          align: 'center',
          slot: 'action',
          width: 120,
          fixed: 'right'
        }
      ],
    };
  },
  watch: {},
  computed: {
    ...mapState(['userInfo'])
  },
  provide() {
    return {
      getAmount: this.getAmount
    };
  },
  activated() {
    this.getList();
  },
  mounted() {
    this.searchForm = _.cloneDeep(searchForm(this));
    this.searchForm[0].data = this.searchForm[0].data.slice(1);
  },
  methods: {
    // toggleHeight() {
    //   if (this.$refs.infoBox.style.height === "auto") {
    //     this.fold = true;
    //     this.$refs.infoBox.style.height = "103px";
    //   } else {
    //     this.fold = false;
    //     this.$refs.infoBox.style.height = "auto";
    //   }
    // },
    getAmount() {
      getAvailableAmountWithdrawLog().then(res => {
        this.availableAmount = res.data.availableAmount;
      });
      waitWithdrawAfter().then(res => {
        this.waitAvailableAmount = res.data.waitAmount;
      });
    },
    async exportList(totalId, commissionDate) {
      this.$Message.info('正在导出文件，请稍等片刻 ');
      const res = await myExportAll(totalId, commissionDate);
      this.downloadProcessing(res);
      this.$Message.success('导出成功');
    },

    downloadProcessing(res) {
      if (res.data.type.includes('application/json')) {
        let reader = new FileReader();
        reader.onload = function (event) {
          let content = reader.result;
          let message = JSON.parse(content).message; // 错误信息
          console.log(message);
          // TODO 错误处理
        };
      }
      const fileName = decodeURI(res.headers['content-disposition'].split(';')[1].split('filename=')[1]);
      const blob = new Blob([res.data]); //构造一个blob对象来处理数据
      // const fileName = "xx.xls";
      //对于<a>标签，只有 Firefox 和 Chrome（内核） 支持 download 属性
      //IE10以上支持blob但是依然不支持download
      if ('download' in document.createElement('a')) {
        //支持a标签download的浏览器
        const link = document.createElement('a'); //创建a标签
        link.download = fileName; //a标签添加属性
        link.style.display = 'none';
        link.href = URL.createObjectURL(blob);
        document.body.appendChild(link);
        link.click(); //执行下载
        URL.revokeObjectURL(link.href); //释放url
        document.body.removeChild(link); //释放标签
      } else {
        //其他浏览器
        navigator.msSaveBlob(blob, fileName);
      }
    },

    //提现
    withDrawal() {
      this.$http({
        url: '/buz/withdrawTotal/checkAmount',
        type: 'GET'
      }).then(res => {
        if (res.data == true) {
          this.$refs.numberWithdrawal.open();
        }
      });
    },
    // getWithDrawal() {
    //   this.$http({
    //     url: '/buz/merchantWithdraw/checkWithdraw',
    //     type: 'GET'
    //   }).then(res => {
    //     if (res.data == true) {
    //       this.$refs.numberWithdrawal.open();
    //     }
    //   });
    // },
    //分页切换页码
    pageChange(pageNo) {
      this.$root.$children[0].isShowLoading = true;
      this.pageNo = pageNo;
      this.getList();
    },
    //列表
    async getList() {
      let obj = {};
      this.searchForm[0].data.forEach(item => {
        obj[item.key] = item.value;
        if (item.key == 'commissionPeriod') {
          if (item.value.length == 2) {
            obj[item.key] = item.value[1];
            if (item.value[0] == '2') {
              if (item.value[1]) {
                obj[item.key] = item.value[1] + '-01';
              }
            }
            if (item.value[0] == '1') {
              if (item.value[1]) {
                obj[item.key] = item.value[1] + '-01-01';
              }
            }
          } else {
            obj[item.key] = '';
          }
          if (item.value[0] == '1') {
            obj.commissionDateType = 1;
          } else if (item.value[0] == '2') {
            obj.commissionDateType = 2;
          }
        }
      });
      try {
        this.$root.$children[0].isShowLoading = true;
        this.getAmount();
        const res = await this.$http({
          url: '/buz/settlementDetail/getMerchantTotal',
          type: 'POST',
          data: {
            pageNo: this.pageNo,
            pageSize: this.pageSize,
            ...obj
          },
          apiPermissionCode: 'settlementManage_1_1_0'
        });
        this.tableDate = res.data;
        this.$root.$children[0].isShowLoading = false;
        this.total = res.total;
      } catch (e) {
        this.$root.$children[0].isShowLoading = false;
      }
    },
    search() {
      this.$refs.searchForm.validate((valid, obj) => {
        if (valid) {
          this.pageNo = 1;
          this.getList();
        }
      });
    },
    //分页切换页码
    pageChange(pageNo) {
      this.$root.$children[0].isShowLoading = true;
      this.pageNo = pageNo;
      this.getList();
    }
  },
  created() {}
};
</script>
<style lang="scss" scoped>
.hasDetail {
  height: 50px;
  background: #f7f7f7;
  line-height: 50px;
  text-indent: 20px;
  color: #272933;
  font-size: 18px;
  margin-bottom: 18px;
}
.info {
  margin-bottom: 15px;
  color: #6e574a;
  line-height: 1.6;
  border-radius: 4px;
  background: linear-gradient(106deg, #fff7ea 0%, #fff1e8 100%);
  padding: 12px 24px;
  font-size: 13px;
  .p2 {
    padding-left: 1.5em;
  }
}
.pageBox {
  margin: 30px 0;
}
.tipMsg {
  margin-left: 20px;
  p {
    line-height: 1.8;
    &:nth-child(1) {
      font-size: 16px;
      margin-bottom: 20px;
    }
  }
}
.content {
  .top {
    padding-bottom: 15px;
  }
  .blocks {
    float: left;
    // width: 300px;
    .tx {
      float: left;
      text-align: center;
      > div:nth-child(2) {
        font-size: 18px;
        font-weight: bold;
        color: #3c464f;
        margin-top: 10px;
      }
    }
    &:nth-child(2) {
      position: relative;
      padding-right: 100px;
      &:after {
        content: '';
        position: absolute;
        right: 0;
        top: 10px;
        width: 1px;
        height: 45px;
        background: #eeeeee;
      }
    }
    &:nth-child(3) {
      padding-left: 100px;
    }
    button {
      margin-left: 80px;
      margin-top: 12px;
    }
  }
  // padding-top: 30px;
  .inner {
    background: #fff;
  }
  /deep/ .formGroup {
    padding: 0;
  }
  .searchBox {
    position: relative;
    margin-bottom: 5px;

    .toggleHeight {
      position: absolute;
      bottom: -20px;
      left: 50%;
      transform: translateX(-50%);
      z-index: 100;
    }

    /deep/ .ivu-input-group {
      z-index: 0;
    }

    /deep/ .ivu-form .ivu-form-item-label {
      text-align: left;
    }

    /deep/ .ivu-form-item-content {
      margin-right: 30px;
    }

    .left {
      float: left;
      width: 86%;
      // overflow: hidden;
    }

    .right {
      position: absolute;
      right: 0;
      top: 0px;

      // width: 180px;
      /deep/ .ivu-btn {
        width: 80px;
        height: 30px;
      }
    }
  }
}
/deep/ .tip-icon {
  margin-left: 3px;
  width: 15px;
  height: 15px;
  border-radius: 15px;
  background: transparent;
  border: 1px solid #ccc;
  color: #ccc;
  display: inline-block;
  text-align: center;
  line-height: 14px;
  font-size: 14px;
  cursor: pointer;
  top: 50%;
}
</style>
